import express, { Router } from 'express';

import * as targetsValidation from '@/modules/targets/targets.validation';
import * as targetsController from '@/modules/targets/targets.controller';

import { validateMiddleware } from '@/shared/utils/middlewares/index';
import userAuthAndCheckPermissions from '@/modules/auth/auth.user.middleware';
import { setAuditFields } from '@/shared/middleware/setAuditFields';
import { AuditMode } from '@/shared/constants/enum.constant';
import { MODULE_LIST } from '@/shared/constants/module.constant';
import { ACTIONS } from '@/shared/constants';

const router: Router = express.Router();

router
  .route('/')
  .get(
    userAuthAndCheckPermissions(MODULE_LIST.TARGETS, ACTIONS.READ),
    validateMiddleware(targetsValidation.getTargets),
    targetsController.getTargetSummary,
  )
  .post(
    userAuthAndCheckPermissions(MODULE_LIST.TARGETS, ACTIONS.CREATE),
    validateMiddleware(targetsValidation.createTargets),
    setAuditFields({ mode: AuditMode.CREATE, companyField: 'companyId' }),
    targetsController.createTargets,
  );

router
  .route('/:id')
  .get(
    userAuthAndCheckPermissions(MODULE_LIST.TARGETS, ACTIONS.READ),
    validateMiddleware(targetsValidation.getTargetsById),
    targetsController.getTargetsById,
  )
  .patch(
    userAuthAndCheckPermissions(MODULE_LIST.TARGETS, ACTIONS.UPDATE),
    validateMiddleware(targetsValidation.updateTargets()),
    setAuditFields({ mode: AuditMode.UPDATE }),
    targetsController.updateTargets,
  )
  .delete(
    userAuthAndCheckPermissions(MODULE_LIST.TARGETS, ACTIONS.DELETE),
    validateMiddleware(targetsValidation.deleteTargetsById),
    targetsController.deleteTargetsById,
  );

export default router;
